/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicySubClassificationQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicySubClassificationQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicySubClassificationQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicySubClassificationQueryOperator>): PolicySubClassificationQueryOperator {
        let obj = Object.assign(new PolicySubClassificationQueryOperator(), model);
        PolicySubClassificationQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicySubClassificationQueryOperator>): PolicySubClassificationQueryOperator {
        if (!model) return null;
        return PolicySubClassificationQueryOperator.newInstance(<PolicySubClassificationQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicySubClassificationQueryOperator) {
        if (!obj) return;

        models.PolicySubClassificationQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicySubClassificationQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicySubClassificationQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy sub-classifications to include
     */
    sub_classifications: Array<models.PolicySubClassification>;

}
